<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'orgManager' }">组织管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加组织机构</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form  :model="orgForm" :rules="actrules" ref="orgForm" label-width="150px" class="demo-ruleForm"  >
            <el-form-item label="组织机构名称" prop="orgName">
                <el-input v-model="orgForm.orgName" placeholder="组织机构名称" style="width: 40%;" ></el-input>
            </el-form-item>
            <!-- 动态显示(如果是三级机构则查询租户所属的所有二级机构，二级就查询所有的一级) -->
            <el-form-item label="上级组织机构" prop="orgLevel" v-if="pidFlag">
                <el-select v-model="pid" placeholder="请选择上级组织机构">
                    <el-option
                            v-for="(item,index) in orgList"
                            :label="item.org_name"
                            :value="item.org_id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="组织机构级别" prop="orgLevel">
                <el-select class="m-1" v-model="orgForm.orgLevel" placeholder="请选择级别" @change="changeorgLevel()">
                    <el-option label="一级组织机构" value="1" >一级组织机构</el-option>
                    <el-option label="二级组织机构" value="2" >二级组织机构</el-option>
                    <el-option label="三级组织机构" value="3" >三级组织机构</el-option>
                    <el-option label="四级组织机构" value="4" >四级组织机构</el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary"  @click="submitForm()" id="primary" :disabled="isorgsubmit">保 存</el-button>
                <el-button @click="close()">关闭</el-button>
            </el-form-item>

        </el-form>

    </div>

</template>
<script>
    export default {
        data() {
            return {
                pidFlag:false,
                isorgsubmit:false,
                orgList:[],
                pid:'',
                orgForm:{
                    orgName:'',
                    orgLevel:'',
                },
                actrules:{
                    orgName: [
                        {required: true,message: '请输入用户名称', trigger: 'blur'}
                    ]
                },
            }
        },
        created(){

        },
        methods: {
            resetForm(formName) {
                this.topForm.orgName = '';
                this.getData();
            },
            submitForm(){
                if(this.pid != ''){
                    //数据请求
                    this.isorgsubmit = true
                    var params = {orgName:this.orgForm.orgName,orgLevel:this.orgForm.orgLevel,
                        tenantId:this.getcookie('storeId'),pid:this.pid};
                    //异步请求
                    this.$http.post(this.requetHost+"/sys/org/saveOrg",params)
                        .then(response => {
                            this.isorgsubmit = false;
                            if (response.status === 200) {
                                if(response.body.Code == '200'){
                                    this.$message({showClose: true,message: '添加成功',type: 'success'});
                                    this.$router.push( {path:"orgManager"});
                                }

                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }else {
                    this.$message({showClose: true,message: '请选择上级机构',type: 'error'});
                }
            },
            changeorgLevel(){

                //判断是否是租户添加的一级组织机构
                if(this.orgForm.orgLevel != '1'){
                    //必须选择他的上级机构
                    this.pidFlag = true;
                    this.pid = '';
                    this.findorgList();
                }else {
                    this.pid = '0';
                    this.pidFlag = false;
                }
                console.log(this.orgList);
            },
            findorgList(){
                var level=parseInt(this.orgForm.orgLevel)-1;
                var params = {level:""+level,
                    tenantId:this.getcookie('storeId'),};
                //异步请求
                this.$http.post(this.requetHost+"/sys/org/findUpOrgList",params)
                    .then(response => {
                        this.isorgsubmit = false;
                        if (response.status === 200) {
                            if(response.body.Code == '200'){
                                this.orgList = response.body.Data;
                            }

                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// OrgAdd.vue?2ede6bbe